export const isDevEnvironment = !process.env.NODE_ENV || process.env.NODE_ENV === 'development'

export const root = document.querySelector(':root');

export const ChartColors = [
  getComputedStyle(root).getPropertyValue('--color-purple-1'),
  getComputedStyle(root).getPropertyValue('--color-red-1'), 
  getComputedStyle(root).getPropertyValue('--color-yellow-1'), 
  getComputedStyle(root).getPropertyValue('--color-green-1'), 
  getComputedStyle(root).getPropertyValue('--color-blue-1'), 
  getComputedStyle(root).getPropertyValue('--color-red-2'), 
  getComputedStyle(root).getPropertyValue('--color-green-2'), 
  getComputedStyle(root).getPropertyValue('--color-purple-2'), 
  getComputedStyle(root).getPropertyValue('--color-blue-2'), 
  getComputedStyle(root).getPropertyValue('--color-yellow-2'), 
];


export const ChartColorsUndergrupper = [
  getComputedStyle(root).getPropertyValue('--color-red-1'), 
  getComputedStyle(root).getPropertyValue('--color-purple-1'), 
  getComputedStyle(root).getPropertyValue('--color-yellow-1'), 
  getComputedStyle(root).getPropertyValue('--color-green-1'), 
  getComputedStyle(root).getPropertyValue('--color-blue-1'), 
];

export const SectorColors = {
  Regioner: getComputedStyle(root).getPropertyValue('--color-blue-1'), 
  Kommuner: getComputedStyle(root).getPropertyValue('--color-red-1'), 
  Staten: getComputedStyle(root).getPropertyValue('--color-purple-1'),  
}

export const ChartColorsDelElementer = [
  getComputedStyle(root).getPropertyValue('--color-purple-1'), 
  getComputedStyle(root).getPropertyValue('--color-red-1'), 
  getComputedStyle(root).getPropertyValue('--color-yellow-1'), 
  getComputedStyle(root).getPropertyValue('--color-green-1'), 
  getComputedStyle(root).getPropertyValue('--color-blue-1'), 
  getComputedStyle(root).getPropertyValue('--color-red-2'), 
  getComputedStyle(root).getPropertyValue('--color-green-2'), 
];


export const Educations = Object.freeze([
  {
    shortname: 'PrimarySchool',
    name: 'Grundskoleuddannelse',
    color: getComputedStyle(root).getPropertyValue('--color-purple-1'),
  },
  {
    shortname: 'Gymnasium',
    name: 'Gymnasial uddannelse',
    color: getComputedStyle(root).getPropertyValue('--color-red-1'),
  },
  {
    shortname: 'Erhversfaglig',
    name: 'Erhvervsfaglig uddannelse',
    color: getComputedStyle(root).getPropertyValue('--color-yellow-1'),
  },
  {
    shortname: 'KVU',
    name: 'Kort videregående uddannelse',
    color: getComputedStyle(root).getPropertyValue('--color-green-1'),
  },
  {
    shortname: 'MVU',
    name: 'Mellemlang videregående uddannelse',
    color: getComputedStyle(root).getPropertyValue('--color-blue-1'),
  },
  {
    shortname: 'Bachelor',
    name: 'Bacheloruddannelse',
    color: getComputedStyle(root).getPropertyValue('--color-red-2'),
  },
  {
    shortname: 'LVU',
    name: 'Lang videregående uddannelse',
    color: getComputedStyle(root).getPropertyValue('--color-green-2'),
  },
  {
    shortname: 'PHD',
    name: 'Ph.d.',
    color: getComputedStyle(root).getPropertyValue('--color-purple-2'),
  }
]);
